/** iOS-style motion presets for the birth-date calendar picker. */

export const iosSpring = { type: 'spring', stiffness: 340, damping: 34, mass: 0.85 };

export const iosSheetSpring = { type: 'spring', stiffness: 300, damping: 32, mass: 0.9 };

export const iosQuartOut = { ease: [0.23, 1, 0.32, 1], duration: 0.35 };

export function calendarTransition(reducedMotion) {
  return reducedMotion ? { duration: 0.01 } : iosSpring;
}

export function calendarSlideVariants(reducedMotion) {
  if (reducedMotion) {
    return {
      enter: { opacity: 0 },
      center: { opacity: 1 },
      exit: { opacity: 0 },
    };
  }

  return {
    enter: (direction = 1) => ({
      opacity: 0,
      x: direction > 0 ? 28 : -28,
      scale: 0.97,
    }),
    center: {
      opacity: 1,
      x: 0,
      scale: 1,
    },
    exit: (direction = 1) => ({
      opacity: 0,
      x: direction > 0 ? -20 : 20,
      scale: 0.98,
      transition: { type: 'spring', stiffness: 400, damping: 38 },
    }),
  };
}

export const calendarTitleVariants = {
  enter: { opacity: 0, y: 6, scale: 0.96 },
  center: { opacity: 1, y: 0, scale: 1 },
  exit: { opacity: 0, y: -4, scale: 0.98 },
};

export const calendarGridItemVariants = {
  hidden: { opacity: 0, scale: 0.9 },
  visible: (index) => ({
    opacity: 1,
    scale: 1,
    transition: {
      type: 'spring',
      stiffness: 420,
      damping: 32,
      delay: Math.min(index * 0.018, 0.22),
    },
  }),
};

export const calendarDayCellVariants = {
  hidden: { opacity: 0, scale: 0.88 },
  visible: (index) => ({
    opacity: 1,
    scale: 1,
    transition: {
      type: 'spring',
      stiffness: 460,
      damping: 34,
      delay: Math.min(index * 0.012, 0.18),
    },
  }),
};

export const calendarSheetVariants = {
  hidden: { opacity: 0, y: '100%' },
  visible: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: '12%' },
};

export const calendarBackdropVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
  exit: { opacity: 0 },
};
